/**
 * Upcoming services exposed by the notify widget and its ADMIN review list.
 * [PLACEHOLDER — CTO feed] Keep this config aligned with clinic-service's
 * authoritative catalogue until the feed becomes available. The deployed
 * booking route is deliberately `testosterone-hormon-panel` (verified 2026-07-31).
 */
export const NOTIFY_SERVICES = [
  ['thyroid-function', 'Thyroid Function'],
  ['diabetes-check', 'Diabetes Check'],
  ['cholesterol-lipids-panel', 'Cholesterol & Lipids Panel'],
  ['full-blood-count', 'Full Blood Count'],
  ['testosterone-hormon-panel', 'Testosterone Hormone Panel'],
  ['adhd-in-children-teens', 'ADHD in Children & Teens'],
  ['anxiety-mental-health', 'Anxiety & Mental Health'],
  ['sti-screen', 'STI Screen'],
] as const;

export const NOTIFY_SERVICE_NAMES: Readonly<Record<string, string>> = Object.fromEntries(NOTIFY_SERVICES);
